import { RosaCoreApiAuthService } from '@/libs/rosa/lib/core/services/auth/core-api-auth.service';
import { RosaCoreLocalStorageKey, type CoreApiToken } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import { ErrorHandlingProvider } from './error-handling/error-handling.provider';
import { APIError } from './errors.constants';
import { InformationProvider } from './information/information.provider';

@Injectable({
    providedIn: 'root'
})
export class CognitoProvider {
    private _informationProvider = inject(InformationProvider);
    private _coreApiAuthService = inject(RosaCoreApiAuthService);
    private _errorHandlingProvider = inject(ErrorHandlingProvider);

    convertIdpAccessTokenToAdvizeoAuthToken(
        idpAccessToken: string | null,
        idpCode: string | null,
        client: string,
        codeVerifier: string | null
    ): Promise<CoreApiToken> {
        const lastProjectId = localStorage.getItem(RosaCoreLocalStorageKey.PROJECT_ID);

        return this._coreApiAuthService
            .convertIdpAccessTokenToAdvizeoAuthToken(client, idpAccessToken, idpCode, codeVerifier, lastProjectId)
            .then(advizeoAuthToken => {
                localStorage.setItem(RosaCoreLocalStorageKey.CONNECTED_WITH_SSO, 'true');
                return advizeoAuthToken;
            })
            .catch(err => {
                const errorCode = this._errorHandlingProvider.getErrorCodeFromApiResponse(err);

                if (errorCode === APIError.UNEXISTING_USER) {
                    this._informationProvider.showToast('COGNITO.CONNECTION_FAIL_UNKNOWN_USER', 'error', 30_000);
                } else if (errorCode === APIError.UNAUTHORIZED) {
                    this._informationProvider.showToast('COGNITO.CONNECTION_FAIL_UNAUTHORIZED', 'error', 30_000);
                } else {
                    this._informationProvider.showToast('COGNITO.CONNECTION_FAIL_GENERIC', 'error', 30_000);
                }

                console.error('failed converting cognito token to advizeo token ::', err);
                return Promise.reject(err);
            });
    }
}
